<div *ngIf="isLoading">
  <H2>Loading...</H2>
</div>

<div *ngIf="isDisplaying">
  <serviceRequest-item *ngFor="let p of serviceRequests" [serviceRequest]="p"></serviceRequest-item>


  <pagination-nav
    [totalPages]="totalPages"
    [currentPage]="currentPage"
    (pageChange)="navigatePage($event)">
  </pagination-nav>
</div>

<div *ngIf="isError">
  <H2>Failed to Load...</H2>
</div>
